import React from 'react'
import { Spin } from 'antd';
import './index.css'

export default function Loading() {
  return <Spin size="large" className="loading-indicator"/>;
}
